import * as React from "react";

import TextInputRA from "../components/TextInputRA";

import StatusInput from "../components/StatusInput";
import RightGridCreate from "../components/RightGridCreate";
import AuthorizeInput from "../components/AuthorizeInput";
import LayoutContainer from "../components/LayoutContainer";
import { Box, Grid } from "@material-ui/core";
import LeftGridCreate from "../components/LeftGridCreate";
import RoleValidation from "../../../ValidationRules/RoleValidation";
import PermissionChecker from "../../../components/PermissionChecker";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
const RoleCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate {...props} validate={RoleValidation}>
      <SfBreadcrumbs path="Management/Roles" />
        <Box style={{margin:" 30px 50px 50px"}}>
          <TextInputRA required label="Name" source="name" />
          <TextInputRA label="Description" source="desc" />
          <StatusInput />
        </Box>
        <AuthorizeInput />
      </LeftGridCreate>
      <RightGridCreate />
    </Grid>
    {/* <Create {...props} title="Create Role">
      <SimpleForm>
        <TextInputRA label="Name" source="name" />
        <TextInputRA label="Description" source="desc" />
        <HiddenInputRA source="status" initialValue="Active" />
        <AuthorizeInput />
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.User" write />
  </LayoutContainer>
);

export default RoleCreate;
